import { render, staticRenderFns } from "./techPro1.vue?vue&type=template&id=7345c89c&scoped=true&"
import script from "./techPro1.vue?vue&type=script&lang=js&"
export * from "./techPro1.vue?vue&type=script&lang=js&"
import style0 from "./techPro1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./techPro1.vue?vue&type=style&index=1&id=7345c89c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7345c89c",
  null
  
)

export default component.exports